//---------------------------------
// apply combat option toggle state
//---------------------------------
export default function applyCombatOptionToggleState({ combatant = {}, options = {} } = {}) {
  const currentShield = Boolean(combatant.shield)
  const currentSecondWeapon = Boolean(combatant.second_weapon)
  let nextShield = Object.hasOwn(options, 'shield') ? Boolean(options.shield) : currentShield
  let nextSecondWeapon = Object.hasOwn(options, 'second_weapon')
    ? Boolean(options.second_weapon)
    : currentSecondWeapon

  if (nextShield && nextSecondWeapon) {
    if (nextShield !== currentShield) {
      nextSecondWeapon = false
    } else if (nextSecondWeapon !== currentSecondWeapon) {
      nextShield = false
    } else {
      nextSecondWeapon = false
    }
  }

  const currentToggleCount = Number(currentShield) + Number(currentSecondWeapon)
  const nextToggleCount = Number(nextShield) + Number(nextSecondWeapon)
  const currentCR = Number(combatant.cr ?? 0)

  return {
    ...options,
    shield: nextShield,
    second_weapon: nextSecondWeapon,
    cr: currentCR + (nextToggleCount - currentToggleCount),
  }
}
